import * as React from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Numbers } from "./Numbers";

type WhoProps = {
  title: string;
  text: string;
  btn?: string;
  link: string;
};

export const Who: React.FC<WhoProps> = ({ title, text, btn, link }) => {
  return (
    <Box
      as="section"
      py={{ base: "20", md: "36" }}
      alignItems="center"
      justifyContent="center"
    >
      <Container maxW={{ base: "3xl", md: "7xl" }} p={0}>
        <Stack
          direction={{ base: "column", lg: "row" }}
          justify="space-between"
          align={{ base: "flex-start", md: "center" }}
          pos="relative"
          px={{ base: "6", md: "0" }}
          gap={{ base: "10", md: "auto" }}
        >
          <Box w="full" maxW="full">
            <Heading
              as="h2"
              fontFamily={"TradeGothic LT Bold"}
              fontSize={"4xl"}
              fontWeight="600"
              textAlign={{
                base: "center",
                sm: "left",
                md: "center",
                lg: "left",
              }}
              textTransform={"uppercase"}
            >
              {title}
            </Heading>
            <Text
              mt="4"
              mb="6"
              fontSize="md"
              color={"#768178"}
              fontWeight="medium"
            >
              {text}
            </Text>
            {/* <Button
              bg="transparent"
              aria-label="read-more-about-citizen-diplomacy"
              color="#D9A542"
              pl={0}
              fontWeight={"bold"}
              textTransform={"uppercase"}
              _hover={{ bg: "transparent" }}
            >
              <Link href={link}>{btn}</Link>
            </Button> */}
          </Box>
          <Box maxW="740px" pos="relative" left={{ base: "0", md: "10" }}>
            <Numbers displayData="home" />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};
